import { render, staticRenderFns } from "./AppAuth.vue?vue&type=template&id=37b1d193&scoped=true&"
import script from "./AppAuth.vue?vue&type=script&lang=js&"
export * from "./AppAuth.vue?vue&type=script&lang=js&"
import style0 from "./AppAuth.vue?vue&type=style&index=0&id=37b1d193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1d193",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b1d193')) {
      api.createRecord('37b1d193', component.options)
    } else {
      api.reload('37b1d193', component.options)
    }
    module.hot.accept("./AppAuth.vue?vue&type=template&id=37b1d193&scoped=true&", function () {
      api.rerender('37b1d193', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/core/Role/components/AppAuth.vue"
export default component.exports